'use client';

import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDraggable } from 'react-use-draggable-scroll';
import TerraImage from './terra-image';

export default function ImageWall() {
    const { t } = useTranslation('terra1-image-wall');

    const imageList: {
        id: string;
        url: string;
        desc: string;
        name: string;
    }[] = t('imageList', { returnObjects: true }) as {
        id: string;
        url: string;
        desc: string;
        name: string;
    }[];

    const ref = useRef<HTMLElement>(
        null,
    ) as React.MutableRefObject<HTMLElement>;
    const { events } = useDraggable(ref, {
        activeMouseButton: 'Left',
        applyRubberBandEffect: true,
    }); // Now we pass the reference to the useDraggable hook:

    return (
        // 构建一个2*5的图片墙，图片名字规则是picn*m.webp，n是行数，m是列数
        <section
            ref={ref}
            className="scrollbar-hide scroll-snap-type-x mandatory flex max-w-full flex-col overflow-x-scroll"
            {...events}
        >
            <div className="scroll-snap-align-start flex flex-row gap-[4px] sm:gap-[8px]">
                {/* 获取imageList前5张 */}
                {imageList.slice(0, 5).map((image) => (
                    <div
                        key={image.id}
                        className="scroll-snap-align-start relative max-h-[120px] min-h-[120px] min-w-[190px] max-w-[190px] sm:max-h-[240px] sm:min-h-[240px] sm:min-w-[420px] sm:max-w-[420px]"
                    >
                        <TerraImage
                            wrapperClassName="h-full w-full"
                            fill
                            sizes="100% 100%"
                            title={image.name}
                            src={image.url}
                            alt={image.desc}
                            skeletonClassName="bg-[#151519]"
                            style={{
                                objectFit: 'cover',
                                transition: 'none', // 添加这一行来取消动画效果
                                userSelect: 'none', // 添加这一行来禁止选中元素的内容
                            }}
                        />
                    </div>
                ))}
            </div>

            <div className="mt-[4px] flex flex-row gap-[4px] sm:mt-[8px] sm:gap-[8px]">
                {/* 获取imageList后5张 */}
                {imageList.slice(5).map((image) => (
                    <div
                        key={image.id}
                        className="scroll-snap-align-start relative max-h-[120px] min-h-[120px] min-w-[190px] max-w-[190px] sm:max-h-[240px] sm:min-h-[240px] sm:min-w-[420px] sm:max-w-[420px]"
                    >
                        <TerraImage
                            wrapperClassName="h-full w-full"
                            fill
                            sizes="100% 100%"
                            title={image.name}
                            src={image.url}
                            alt={image.desc}
                            skeletonClassName="bg-[#151519]"
                            style={{
                                objectFit: 'cover',
                                transition: 'none', // 添加这一行来取消动画效果
                                userSelect: 'none', // 添加这一行来禁止选中元素的内容
                            }}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}
